import React from "react";
import PropTypes from "prop-types";
import Highlight from "react-highlighter";

class Content extends React.Component {
  render() {
    const { searchString, data } = this.props;

    function strip(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }

    return (
      <div>
        {data.subject ? (
          <p style={{ marginBottom: 8 }}>
            Subject:{" "}
            {
              <Highlight matchClass="highlighted" search={searchString}>
                {data.subject}
              </Highlight>
            }
          </p>
        ) : null}

        <div className="grey-text">
          {searchString ? (
            <Highlight matchClass="highlighted" search={searchString}>
              {strip(data.content)}
            </Highlight>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: data.content }} />
          )}
        </div>
      </div>
    );
  }
}

Content.propTypes = {
  searchString: PropTypes.string,
  data: PropTypes.object.isRequired
};

export default Content;
